import { css } from '@emotion/react';
import { DesignToken, RadiusToken, SpacingToken } from '@livechat/design-system-react-components';

export const productsContainerStyles = css`
  margin-top: var(${SpacingToken.Spacing2});

  a {
    text-decoration: none;
  }
`;

export const noProductsTextStyles = css`
  text-align: left;
  padding: 0 var(${SpacingToken.Spacing4});
`;

export const goToProductContainerStyles = css`
  display: flex;
  align-items: center;
  padding: var(${SpacingToken.Spacing2}) var(${SpacingToken.Spacing4});
  border-radius: var(${RadiusToken.Radius3});

  &:hover {
    background-color: var(${DesignToken.SurfaceSecondaryDefault});
    cursor: pointer;
  }
`;

export const goToProductStyles = css`
  margin: 0 var(${SpacingToken.Spacing2});
  min-width: fit-content;
`;

export const accountsLogoStyles = css`
  height: 24px;
  width: 24px;
`;

export const linkStyles = css`
  color: var(${DesignToken.ContentBasicPrimary});
`;
